export default __webpack_public_path__ + "static/media/home-bg.26df7164.png";